const FETCH_NATIVE_SHARE_DATA_EVENT_TYPE = "app:product:fetchShareData";
const APP_SHARE_EVENT_TYPE = "app:product:shareData";
const DEFAULT_TRACKING_PARAMETERS = "landmark=Entry&typ=SoM&anbieter=Share&aktion=SocialMedia&version=ADA&bkkz=260000000";

let shareContext = {};
let currentProduct = {
    style: null,
    item: null,
    itemOption: null
};
let appSupportsSharing = false;

function addOnShareDataRequestedListener(callback) {
    document.addEventListener(FETCH_NATIVE_SHARE_DATA_EVENT_TYPE, () => {
        appSupportsSharing = true;
        callback?.();
    });
}

function publishShareContext() {
    if (!shareContext) {
        return;
    }
    const shareEvent = new Event(APP_SHARE_EVENT_TYPE);
    shareEvent.detail = shareContext;
    document.dispatchEvent(shareEvent);
}

function updateShareContext(initialProductData, shareContextUpdater) {
    //initial share context build
    currentProduct = {
        style: initialProductData.currentStyle,
        item: initialProductData.currentItem,
        itemOption: initialProductData.currentItemOption
    };
    shareContext = shareContextUpdater?.(currentProduct);

    //update share context
    return ({style, item, itemOption}) => {
        if (style !== undefined) {
            currentProduct.style = style;
        }
        if (item !== undefined) {
            currentProduct.item = item;
        }
        if (itemOption !== undefined) {
            currentProduct.itemOption = itemOption;
        }
        shareContext = shareContextUpdater?.(currentProduct);
        if (appSupportsSharing) {
            publishShareContext();
        }
    };
}

export default {
    addOnShareDataRequestedListener,
    publishShareContext,
    updateShareContext,
    DEFAULT_TRACKING_PARAMETERS
}

